import { type BackNavigation, navigatorActions } from '../context/context';
import { useNavigatorContext } from '../context/NavigatorContext';

const useNavigator = () => {
  const { state, dispatch } = useNavigatorContext();

  const setIsOnline = (isOnline: boolean) => {
    dispatch({
      type: navigatorActions.SET_IS_ONLINE,
      payload: isOnline
    });
  };

  const setBackNavigation = (backNavigation: BackNavigation) => {
    dispatch({
      type: navigatorActions.SET_BACK_NAVIGATION,
      payload: backNavigation
    });
  };

  const setLogoClicked = (logoClicked: boolean) => {
    dispatch({
      type: navigatorActions.SET_LOGO_CLICKED,
      payload: logoClicked
    });
  };

  return {
    navigatorState: state,
    setBackNavigation,
    setLogoClicked,
    setIsOnline
  };
};

export default useNavigator;
